import React from 'react'
import {
  Button,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'
import DateTime from 'react-datetime'
import moment from 'moment'

import AirlineSearchSelect from '../airline/AirlineSearchSelect'
import StationSearchSelect from '../station/StationSearchSelect'
import ServiceSearchSelect from '../service/ServiceSearchSelect'
import { checkIfAnyGrantedByGivenAuth } from '../../modules/authService'
import { archivedDataAccess } from '../../modules/accessList'

export default ({
  filter,
  onFilterChange,
  onDownloadCSV,
  onDownloadPDF,
  isDownloadable,
  onViewWebClick,
  auth,
}) => (
  <div className="container">
    <div className="panel panel-default">
      <div className="panel-body">
        <div className="flex items-center gap-3 mb-4">
          <button
            onClick={() => window.history.back()}
            className="flex items-center gap-2 px-3 py-2 text-gray-600 bg-transparent border-none hover:bg-gray-100 rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-5 h-5"
            >
              <path
                fillRule="evenodd"
                d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z"
                clipRule="evenodd"
              />
            </svg>
            Back
          </button>
          <h1 className="my-0">Airline Report</h1>
        </div>
        <hr />
        <Form horizontal>
          <FormGroup controlId="startDate">
            <Col componentClass={ControlLabel} sm={4}>
              Start Date*
            </Col>
            <Col sm={6}>
              <DateTime
                value={filter.startDate}
                onChange={(value) => {
                  if (value && !moment.isMoment(value)) return
                  onFilterChange('startDate', value)
                }}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ placeholder: 'Start Date' }}
              />
            </Col>
          </FormGroup>

          <FormGroup controlId="endDate">
            <Col componentClass={ControlLabel} sm={4}>
              End Date*
            </Col>
            <Col sm={6}>
              <DateTime
                value={filter.endDate}
                onChange={(value) => {
                  if (value && !moment.isMoment(value)) return
                  onFilterChange('endDate', value)
                }}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ placeholder: 'End Date' }}
              />
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalAirline">
            <Col componentClass={ControlLabel} sm={4}>
              Flight Number
            </Col>
            <Col sm={6}>
              <FormControl
                type="text"
                value={filter.flightNumber}
                placeholder="Flight Number"
                onChange={(e) => onFilterChange('flightNumber', e.target.value)}
              />
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalAirline">
            <Col componentClass={ControlLabel} sm={4}>
              Airline
            </Col>

            <Col sm={6}>
              <AirlineSearchSelect
                value={filter.airlineId}
                onChange={(value) => onFilterChange('airlineId', value)}
                placeholder="Airline"
                selectValue={(airline) => airline._id}
              />
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalAirline">
            <Col componentClass={ControlLabel} sm={4}>
              Service*
            </Col>

            <Col sm={6}>
              <ServiceSearchSelect
                required={true}
                value={filter.service}
                onChange={(value) => onFilterChange('service', value)}
                placeholder={'Service'}
              />
            </Col>
          </FormGroup>

          <FormGroup controlId="formHorizontalAirline">
            <Col componentClass={ControlLabel} sm={4}>
              Station
            </Col>

            <Col sm={6}>
              <StationSearchSelect
                name="stationId"
                value={filter.stationId}
                onChange={(value) => onFilterChange('stationId', value)}
                placeholder="Station"
                selectValue={(station) => station._id}
              />
            </Col>
          </FormGroup>

          {auth && checkIfAnyGrantedByGivenAuth(auth, archivedDataAccess) && (
            <FormGroup controlId="formHorizontalArchived">
              <Col componentClass={ControlLabel} sm={4}>
                Search Archived
              </Col>

              <Col sm={6}>
                <div className="flex items-center" style={{ paddingTop: '7px' }}>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={filter.searchArchived || false}
                      onChange={(e) =>
                        onFilterChange('searchArchived', e.target.checked)
                      }
                    />
                    <span>Include archived data</span>
                  </label>
                </div>
              </Col>
            </FormGroup>
          )}

          <FormGroup className="space-y-4 md:space-y-0">
            <Col smOffset={0} sm={4}>
              <Button
                bsStyle="primary"
                onClick={onDownloadCSV}
                disabled={!isDownloadable}
                className="flex flex-row w-full justify-center items-center space-x-3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
                </svg>
                <span>Send me CSV</span>
              </Button>
            </Col>

            <Col sm={4}>
              <Button
                bsStyle="primary"
                onClick={onDownloadPDF}
                disabled={!isDownloadable}
                className="flex flex-row w-full justify-center items-center space-x-3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
                </svg>
                <span>Send me PDF</span>
              </Button>
            </Col>

            <Col sm={4}>
              <Button
                bsStyle="primary"
                onClick={onViewWebClick}
                disabled={!isDownloadable}
                className="flex flex-row w-full justify-center items-center space-x-3"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z"
                    clipRule="evenodd"
                  />
                  <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                </svg>
                <span>View on Web</span>
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </div>
    </div>
  </div>
)
